import { render, staticRenderFns } from "./PreviewElImageV2.vue?vue&type=template&id=f477065a"
import script from "./PreviewElImageV2.vue?vue&type=script&lang=js"
export * from "./PreviewElImageV2.vue?vue&type=script&lang=js"
import style0 from "./PreviewElImageV2.vue?vue&type=style&index=0&id=f477065a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports